"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _mapObjIndexed = _interopRequireDefault(require("ramda/es/mapObjIndexed"));

/* eslint-disable no-underscore-dangle */
var ComponentRegistry =
/*#__PURE__*/
function () {
  function ComponentRegistry() {
    (0, _classCallCheck2["default"])(this, ComponentRegistry);
    (0, _defineProperty2["default"])(this, "_previewComponents", {});
    (0, _defineProperty2["default"])(this, "_components", {});
    (0, _defineProperty2["default"])(this, "_editable", {});
  }

  (0, _createClass2["default"])(ComponentRegistry, [{
    key: "registerPreview",
    value: function () {
      function registerPreview(name, component) {
        this._previewComponents[name] = component;
      }

      return registerPreview;
    }()
  }, {
    key: "register",
    value: function () {
      function register(name, component, editable) {
        this._components[name] = component;
        this._editable[name] = editable;
      }

      return register;
    }()
  }, {
    key: "get",
    value: function () {
      function get(name) {
        return this._components[name];
      }

      return get;
    }()
  }, {
    key: "getEditable",
    value: function () {
      function getEditable(name) {
        return this._editable[name];
      }

      return getEditable;
    }()
  }, {
    key: "getPreview",
    value: function () {
      function getPreview(name) {
        return this._previewComponents[name];
      }

      return getPreview;
    }()
  }, {
    key: "configure",
    value: function () {
      function configure(config) {
        var _this = this;

        (0, _mapObjIndexed["default"])(function (comp, name) {
          var _comp$component = comp.component,
              component = _comp$component === void 0 ? comp : _comp$component,
              editable = comp.editable;

          _this.register(name, component, editable);
        }, config.components);
        (0, _mapObjIndexed["default"])(function (preview, name) {
          _this.registerPreview(name, preview);
        }, config.previews);
      }

      return configure;
    }()
  }]);
  return ComponentRegistry;
}();

var _default = ComponentRegistry;
exports["default"] = _default;